import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'Published' },
    { value: 3, label: 'Open' },
    { value: 4, label: 'Closed' },
    { value: 5, label: 'Cancelled' },
    { value: 6, label: 'Completed' },
    { value: 7, label: 'Archived' },
  ],
});
